<template>
	<div id="app"><router-view /></div>
</template>
<script>
export default {
	name: 'App'
};
</script>
<style>
body {
	background-color: #f5f7f9;
}

.flex-align-center {
	display: flex;
	align-items: center;
}

/* 上传 */
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 150px;
	height: 150px;
	line-height: 150px;
	text-align: center;
}
</style>
